import { buildApiRequest } from 'utils/api';
import { BASE_URL } from 'utils/urls';

const urlHelper = {
  getIssues: (params) => buildApiRequest('GET', `${BASE_URL}/odin/v1/ticket/config/issue/${params}`),
  updateIssue: (params) => buildApiRequest('POST', `${BASE_URL}/odin/v1/ticket/config/issue`, params),
};

export default urlHelper;
